import DomReady from "../vendors/domready.js"
import A11yModalButton from "./modules/a11y-modal-button"
import A11yPopupButton from "./modules/a11y-popup-button"
import A11yBlockLink from "./modules/a11y-block-link"
import A11yAutofocus from "./modules/a11y-autofocus"
import "./modules/a11y-input-enter-click"

DomReady(() => {

  [...document.querySelectorAll(".js-a11y-modal-button")].forEach((element) => {
    let button = new A11yModalButton(element);
    button.init();
  });

  [...document.querySelectorAll(".js-a11y-popup-button")].forEach((element) => {
    let button = new A11yPopupButton(element);
    button.init();
  });

  [...document.querySelectorAll(".js-a11y-block-link")].forEach((element) => {
    let blocklink = new A11yBlockLink(element);
    blocklink.init();
  });

  [...document.querySelectorAll(".js-a11y-autofocus")].forEach((element) => {
    let autofocus = new A11yAutofocus(element);
    autofocus.init();
  });
})
